import { useMutation, useQueryClient } from '@tanstack/react-query';
import { post } from '@/shared/api/api-client';
import type { MergePatientsRequest } from '@/types/patient-api';

/** POST /api/Patients/Merge with { parentPatient, childPatients }. */
export function useMergePatients() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (req: MergePatientsRequest) =>
      post<void>('/api/Patients/Merge', req),
    onSuccess: (_data, vars) => {
      qc.invalidateQueries({ queryKey: ['patients-list'] });
      qc.invalidateQueries({ queryKey: ['patient', vars.parentPatient] });
      vars.childPatients.forEach((id) =>
        qc.invalidateQueries({ queryKey: ['patient', id] }),
      );
    },
  });
}
